import React, { Fragment } from 'react'

import ProfileIcon from 'custom/assets/common-icons/Profile.svg'
import NotificationIcon from 'custom/assets/common-icons/Notification_Icon.svg'
import ChangePasswordIcon from 'custom/assets/common-icons/Change_Password.svg'

import Dashboard_DepositIcon from 'custom/assets/dashboard/TermDesposits.svg'
// import Dashboard_OtherServicesIcon from 'custom/assets/common-icons/Download_center.svg'
import Dashboard_LoansIcon from 'custom/assets/dashboard/loan.svg'
import Dashboard_PaymentsIcon from 'custom/assets/dashboard/payments.svg'
import Dashboard_TransfersIcon from 'custom/assets/dashboard/transfers.svg'
import Dashboard_PortfolioIcon from 'custom/assets/dashboard/portfolio.svg'
import Dashboard_AccountsIcon from 'custom/assets/dashboard/accounts.svg'
import Dashboard_RequestIcon from 'custom/assets/common-icons/Request.svg'
import Other_SupportCenterIcon from 'custom/assets/common-icons/Support_Center.svg'
import Dashboard_OtherServicesIcon from 'custom/assets/dashboard/otherServices.svg'
import Dashboard_ExchangeIcon from 'custom/assets/quick-links/exchange.svg'
import GimacIcon from 'custom/assets/gimacpay/gimac.svg'
// import i18n from '../../i18n'
import { MENU_KEYS } from '../../utils/translation-constants'

export const MENU_DETAILS = [
  {
    title: MENU_KEYS.STATEMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'STATEMENTS',
    link: '/statement',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_KEYS.CARDLESS_CASH,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNT_CARDLESS_CASH',
    link: '/accounts/cardless-cash',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_KEYS.GENERATE_TOKEN,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNT_CARDLESS_GENERATE_TOKEN',
    link: '/accounts/cardless-cash/generate',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.CARDLESS_CASH,
        link: '/accounts/cardless-cash',
      },
    ],
  },

  {
    title: MENU_KEYS.DETAILED_STATEMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'DETAILED_STATEMENT',
    link: '/detailed-statement',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.STATEMENT,
        link: '/statement',
      },
    ],
  },

  {
    title: MENU_KEYS.PROFILE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: ProfileIcon,
    parentIcon: ProfileIcon,
    breadCumKey: 'PROFILE',
    link: '/profile',
    parent: [],
  },

  {
    title: MENU_KEYS.CHANGE_PASSWORD,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: ChangePasswordIcon,
    parentIcon: ChangePasswordIcon,
    breadCumKey: 'CHANGE_PASSWORD',
    link: '/change-password',
    parent: [],
  },

  {
    title: MENU_KEYS.NOTIFICATION,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: NotificationIcon,
    parentIcon: NotificationIcon,
    breadCumKey: 'NOTIFICATION',
    link: '/notifications',
    parent: [],
  },

  {
    title: MENU_KEYS.ACCOUNTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNTS',
    link: '/accounts',
    parent: [],
  },

  {
    title: MENU_KEYS.DOWNLOAD_CENTER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'DOWNLOAD_CENTER',
    link: '/download-center',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.DOWNLOAD_RECIEPT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'RECEIPTS',
    link: '/receipts',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_KEYS.DOWNLOAD_RECIEPT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'DOWNLOAD_RECEIPTS',
    link: '/beneficiary-transfers/download-receipt',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.DOWNLOAD_RECIEPT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'DOWNLOAD_RECEIPTS_PAYMENTS',
    link: '/payments/download-receipt',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.BI_STATEMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'BI',
    link: '/biStatement',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNATIONAL_MT103,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'MT103',
    link: '/mt103',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_KEYS.SUPPORT_CENTER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'SUPPORT_CENTER',
    link: '/support-center',
    parent: [],
  },

  {
    title: MENU_KEYS.FAQ,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'FAQ',
    link: '/faq',
    parent: [
      {
        title: MENU_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_KEYS.SUGGESTIONS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'SUGGESTION',
    link: '/suggestion',
    parent: [
      {
        title: MENU_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_KEYS.BRANCH,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'BRANCH',
    link: '/branch',
    parent: [
      {
        title: MENU_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_KEYS.CONTACT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'CONTACT_US',
    link: '/contact-us',
    parent: [
      {
        title: MENU_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_KEYS.ABOUT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Other_SupportCenterIcon,
    parentIcon: Other_SupportCenterIcon,
    breadCumKey: 'ABOUT_US',
    link: '/about-us',
    parent: [
      {
        title: MENU_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_KEYS.OTHER_SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'ADDITIONAL_LINKS',
    link: '/additional-links',
    parent: [],
  },

  {
    title: MENU_KEYS.CALCULATE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'CALCULATOR',
    link: '/calculator',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.TC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'TERMS_AND_CONDITIONS',
    link: '/terms-and-conditions',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.OFFER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'OFFERS',
    link: '/offers',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.EXCHANGE_RATE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_ExchangeIcon,
    parentIcon: Dashboard_ExchangeIcon,
    breadCumKey: 'EXCHANGE_RATES',
    link: '/exchange-rate',
    parent: [],
  },

  {
    title: MENU_KEYS.PORTFOLIO,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PortfolioIcon,
    parentIcon: Dashboard_PortfolioIcon,
    breadCumKey: 'PORTFOLIO',
    link: '/portfolio',
    parent: [],
  },

  {
    title: MENU_KEYS.LOANS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'LOANS',
    link: '/loans',
    parent: [],
  },

  {
    title: MENU_KEYS.APPLYLOAN,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'APPLY_LOAN',
    link: '/loans/apply',
    parent: [
      {
        title: MENU_KEYS.LOANS,
        link: '/loans',
      },
    ],
  },

  {
    title: MENU_KEYS.MAKELOAN,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'LOAN_PAYMENT',
    link: '/loans/repayment',
    parent: [
      {
        title: MENU_KEYS.LOANS,
        link: '/loans',
      },
    ],
  },

  {
    title: MENU_KEYS.TERMDEPOSITE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DepositIcon,
    parentIcon: Dashboard_DepositIcon,
    breadCumKey: 'DEPOSIT',
    link: '/deposits',
    parent: [],
  },

  {
    title: MENU_KEYS.CREATE_TERM_DEPOSITS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DepositIcon,
    parentIcon: Dashboard_DepositIcon,
    breadCumKey: 'TERM_DEPOSIT',
    link: '/create-term-deposits',
    parent: [
      {
        title: MENU_KEYS.TERMDEPOSITE,
        link: '/deposits',
      },
    ],
  },

  {
    title: MENU_KEYS.PAYMENTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PAYMENTS',
    link: '/payments',
    parent: [],
  },

  {
    title: MENU_KEYS.SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PRODUCTS',
    link: '/payments/products/list',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.PAY_BILL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PAY_BILLS',
    link: '/payments/payBills',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BILLER_SERVICES_VIEW',
    link: '/payments/servicesView',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.PAY_BILL,
        link: '/payments/payBills',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PRODUCTS_FORM',
    link: '/payments/products',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.SERVICES,
        link: '/payments/products/list',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BILLER_SERVICE_FORM',
    link: '/payments/services/product',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.SERVICES,
        link: '/payments/servicesView',
      },
    ],
  },

  {
    title: MENU_KEYS.SCHOOL_PAYMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'SCHOOL_PAYMENT',
    link: '/schoolPayments',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.SERVICES,
        link: '/payments/products/list',
      },
    ],
  },

  {
    title: MENU_KEYS.OTHER_PAYMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'OTHER_PAYMENT',
    link: '/otherPayments',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.SERVICES,
        link: '/payments/products/list',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'TOP_UP_FORM',
    link: '/payments/top-ups',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.BUY_AIR,
        link: '/payments/top-ups/list',
      },
    ],
  },

  {
    title: MENU_KEYS.BUY_DATA,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BUY_DATA',
    link: '/payments/buyData/list',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BUY_DATA_FORM',
    link: '/payments/buyData',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
      {
        title: MENU_KEYS.BUY_DATA,
        link: '/payments/buyData/list',
      },
    ],
  },

  {
    title: MENU_KEYS.BUY_AIR,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'TOP_UP',
    link: '/payments/top-ups/list',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.VIEW_BILLER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'VIEW_BILLER',
    link: '/payments/biller-list',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.ADD_BILLER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'ADD_BILLER',
    link: '/payments/add-biller',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.TRANSFERS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS',
    link: '/beneficiary-transfers',
    parent: [],
  },

  {
    title: MENU_KEYS.BENEFICIARY_ADD,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'ADD_BENE',
    link: '/beneficiary-transfers/add-beneficiary',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.REPEATE_PAYMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_REPEAT',
    link: '/beneficiary-transfers/repeat-payment',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.DOWNLOAD_CENTER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'DOWNLOAD_BENE',
    link: '/beneficiary-transfers/download-center',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.MT103,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_MT103',
    link: '/beneficiary-transfers/download-center/mt103',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/beneficiary-transfers/download-center',
      },
    ],
  },

  {
    title: MENU_KEYS.DOWNLOAD_RECIEPT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_RECIEPT',
    link: '/beneficiary-transfers/download-center/reciept',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/beneficiary-transfers/download-center',
      },
    ],
  },

  {
    title: MENU_KEYS.BI_STATEMENT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_BI',
    link: '/beneficiary-transfers/download-center/bi',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.DOWNLOAD_CENTER,
        link: '/beneficiary-transfers/download-center',
      },
    ],
  },
  {
    title: MENU_KEYS.VIEW_SCHEDULED_TRANSFERS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'SCHEDULED_TRANSFERS',
    link: '/beneficiary-transfers/viewScheduled',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.MAKE_TRANSFER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_TRANSFER',
    link: '/beneficiary-transfers/transfers',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.VIEW_BENEFICIARIES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_VIEW',
    link: '/beneficiary-transfers/view',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL_MODIFY',
    link: '/beneficiary-transfers/edit-beneficiary/internal',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.VIEW_BENEFICIARIES,
        link: '/beneficiary-transfers/view',
      },
    ],
  },

  {
    title: MENU_KEYS.DOMESTIC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_DOMESTIC_MODIFY',
    link: '/beneficiary-transfers/edit-beneficiary/other',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.VIEW_BENEFICIARIES,
        link: '/beneficiary-transfers/view',
      },
    ],
  },
  {
    title: MENU_KEYS.REGIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_REGIONAL_MODIFY',
    link: '/beneficiary-transfers/edit-beneficiary/regional',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.VIEW_BENEFICIARIES,
        link: '/beneficiary-transfers/view',
      },
    ],
  },
  {
    title: MENU_KEYS.INTERNATIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNATIONAL_MODIFY',
    link: '/beneficiary-transfers/edit-beneficiary/international',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.VIEW_BENEFICIARIES,
        link: '/beneficiary-transfers/view',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL_MODIFY',
    link: '/beneficiary-transfers/edit-beneficiary/internal',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.VIEW_BENEFICIARIES,
        link: '/beneficiary-transfers/view',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_INTERNAL',
    link: '/beneficiary-transfers/transfers/internal',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.MAKE_TRANSFER,
        link: '/beneficiary-transfers/transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.DOMESTIC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_OTHER',
    link: '/beneficiary-transfers/transfers/other',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.MAKE_TRANSFER,
        link: '/beneficiary-transfers/transfers',
      },
    ],
  },
  {
    title: MENU_KEYS.REGIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_REGIONAL',
    link: '/beneficiary-transfers/transfers/regional',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.MAKE_TRANSFER,
        link: '/beneficiary-transfers/transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNATIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_INTERNATIONAL',
    link: '/beneficiary-transfers/transfers/international',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.MAKE_TRANSFER,
        link: '/beneficiary-transfers/transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.OWN,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_OWN',
    link: '/beneficiary-transfers/transfers/own',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.MAKE_TRANSFER,
        link: '/beneficiary-transfers/transfers',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL',
    link: '/beneficiary-transfers/add-beneficiary/internal',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.BENEFICIARY_ADD,
        link: '/beneficiary-transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_KEYS.DOMESTIC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_DOMESTIC',
    link: '/beneficiary-transfers/add-beneficiary/domestic',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.BENEFICIARY_ADD,
        link: '/beneficiary-transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_KEYS.REGIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_REGIONAL',
    link: '/beneficiary-transfers/add-beneficiary/regional',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.BENEFICIARY_ADD,
        link: '/beneficiary-transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_KEYS.INTERNATIONAL,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNATIONAL',
    link: '/beneficiary-transfers/add-beneficiary/international',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.BENEFICIARY_ADD,
        link: '/beneficiary-transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_KEYS.QUICK_PAY,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNTS_QUICK_PAY',
    link: '/accounts/quick-pay',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'TRANSFERS_QUICK_PAY_SERVICE_FORM',
    link: '/beneficiary-transfers/quick-pay/services/product',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/beneficiary-transfers/quick-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.FORM,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'ACCOUNTS_QUICK_PAY_SERVICE_FORM',
    link: '/accounts/quick-pay/services/product',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'TRANSFERS_QUICK_PAY_SERVICES_VIEW',
    link: '/beneficiary-transfers/quick-pay/servicesView',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/beneficiary-transfers/quick-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.SERVICES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'ACCOUNTS_QUICK_PAY_SERVICES_VIEW',
    link: '/accounts/quick-pay/servicesView',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.SEND_TO_WALLET,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'SEND_TO_MOBILE',
    link: '/quick-pay/wallet',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/quick-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.QR_PAY,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'QR_CODE',
    link: '/quick-pay/qr',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.REQUEST,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST',
    link: '/requests',
    parent: [],
  },

  {
    title: MENU_KEYS.CHEQUE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE',
    link: '/requests/cheque',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_KEYS.STANDING_INSTRUCTION,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'SI',
    link: '/requests/standing-instruction',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_KEYS.DEBIT_CARD,
    desc: MENU_KEYS.DEBIT_CARD_DESC,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'DEBIT_CARD',
    link: '/requests/debitCard',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_KEYS.DEBIT_CARD_REQUEST,
    desc: MENU_KEYS.DEBIT_CARD_REQUEST_DESC,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'DEBIT_CARD_REQUEST',
    link: '/requests/debitCard/cardRequest',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },

      {
        title: MENU_KEYS.DEBIT_CARD,
        link: '/requests/debitCard',
      },
    ],
  },

  {
    title: MENU_KEYS.DEBIT_CARD_BLOCK,
    desc: MENU_KEYS.DEBIT_CARD_BLOCK,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'DEBIT_CARD_BLOCK',
    link: '/requests/debit-card/block-debit-card',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },

      {
        title: MENU_KEYS.DEBIT_CARD,
        link: '/requests/debitCard',
      },
    ],
  },

  {
    title: MENU_KEYS.DEBIT_CARD_ISSUE,
    desc: MENU_KEYS.DEBIT_CARD_ISSUE_DESC,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'DEBIT_CARD_ISSUE',
    link: '/requests/debitCard/cardIssue',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },

      {
        title: MENU_KEYS.DEBIT_CARD,
        link: '/requests/debitCard',
      },
    ],
  },

  {
    title: MENU_KEYS.CREATE_SI,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'SI_CREATE',
    link: '/requests/standing-instruction/create',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
      {
        title: MENU_KEYS.STANDING_INSTRUCTION,
        link: '/requests/standing-instruction',
      },
    ],
  },

  {
    title: MENU_KEYS.CHEQUEBOOK_REQUEST,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE_BOOK',
    link: '/requests/cheque/cheque-book-request',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
      {
        title: MENU_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },

  {
    title: MENU_KEYS.STOP_CHEQUE,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_STOP_CHEQUE',
    link: '/requests/cheque/stop-cheque-payment',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
      {
        title: MENU_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },
  {
    title: MENU_KEYS.CHEQUE_STATUS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE_STATUS',
    link: '/requests/cheque/cheque-status',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
      {
        title: MENU_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },

  {
    title: MENU_KEYS.CHEQUE_BOOK_STATUS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE_BOOK_STATUS',
    link: '/requests/cheque/chequeBook-status',
    parent: [
      {
        title: MENU_KEYS.REQUEST,
        link: '/requests',
      },
      {
        title: MENU_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },

  {
    title: MENU_KEYS.LINK_ACCOUNT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'LINK_ACCOUNT',
    link: '/link-account',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.DELINK_ACCOUNT,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'DE_LINK_ACCOUNT',
    link: '/deLink-account',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.ACCOUNT_NAME,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'SET_ACCOUNT_NAME',
    link: '/add-accountName',
    parent: [
      {
        title: MENU_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_KEYS.OPEN_ACCOUNT,
    desc: MENU_KEYS.OPEN_NEW_ACCOUNT,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ADD_ACCOUNT',
    link: '/add-account',
    parent: [
      {
        title: 'Accounts',
        link: '/accounts',
      },
    ],
  },
  {
    title: MENU_KEYS.CURRENTMONTH,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'CURRENT_MONTH',
    link: '/currentMonth',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },
  {
    title: MENU_KEYS.LASTTWOMONTH,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LAST_TWO_MONTH',
    link: '/lastTwoMonth',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },
  {
    title: MENU_KEYS.LASTTHREEMONTH,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LAST_THREE_MONTH',
    link: '/lastThreeMonth',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },
  {
    title: MENU_KEYS.CUSTOMDATES,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'CUSTOM_DATES',
    link: '/customDates',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },
  {
    title: MENU_KEYS.QUICK_PAY,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS_QUICK_PAY',
    link: '/beneficiary-transfers/quick-transfer',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
    ],
  },
  {
    title: MENU_KEYS.INSTANT_TRANSFER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS_INSTANT_TRANSFER',
    link: '/beneficiary-transfers/quick-pay/instant-transfer',
    parent: [
      {
        title: MENU_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/beneficiary-transfers/quick-pay',
      },
    ],
  },
  {
    title: MENU_KEYS.INSTANT_TRANSFER,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'ACCOUNTS_INSTANT_TRANSFER',
    link: '/accounts/quick-pay/instant-transfer',
    parent: [
      {
        title: MENU_KEYS.ACCOUNTS,
        link: '/accounts',
      },
      {
        title: MENU_KEYS.QUICK_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },
  {
    title: MENU_KEYS.VIEW_SCHEDULED_PAYMENTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'SCHEDULED_PAYMENTS',
    link: '/payments/viewScheduled',
    parent: [
      {
        title: MENU_KEYS.PAYMENTS,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_KEYS.GIMAC,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    parentIcon: GimacIcon,
    breadCumKey: 'GIMACPAY',
    link: '/gimac-pay',
    parent: [],
  },

  {
    title: MENU_KEYS.PAYMENTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    parentIcon: GimacIcon,
    breadCumKey: 'GIMAC_PAYMENT',
    link: '/gimac-pay/payment',
    parent: [
      {
        title: MENU_KEYS.GIMAC,
        link: '/gimac-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.TRANSFERS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    parentIcon: GimacIcon,
    breadCumKey: 'GIMAC_TRANSFER',
    link: '/gimac-pay/transfer',
    parent: [
      {
        title: MENU_KEYS.GIMAC,
        link: '/gimac-pay',
      },
    ],
  },

  {
    title: MENU_KEYS.ATM_PROVISION,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    parentIcon: GimacIcon,
    breadCumKey: 'GIMAC_ATM',
    link: '/gimac-pay/atm',
    parent: [
      {
        title: MENU_KEYS.GIMAC,
        link: '/gimac-pay',
      },
    ],
  },

  {
    title: 'Transfer / Payment Reciepts',
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: GimacIcon,
    parentIcon: GimacIcon,
    breadCumKey: 'GIMAC_RECIEPTS',
    link: '/gimac-pay/reciepts',
    parent: [
      {
        title: MENU_KEYS.GIMAC,
        link: '/gimac-pay',
      },
    ],
  },
]
